module.exports = __webpack_public_path__ + "./docs/img/icon-events.f57d4b28b8eb5011e0a83c65a15fa379.svg";